"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesSerializer = void 0;
const helpers_1 = require("../helpers");
class RolesSerializer {
    constructor() { }
    serializeOne(data) {
        return {
            activeRole: data.current_active_role
                ? (0, helpers_1.getValidCognitoRole)(data.current_active_role)
                : undefined,
            availableRoles: data.current_roles_available
                ? (0, helpers_1.getCognitoRolesFrom)(data.current_roles_available)
                : undefined,
        };
    }
}
exports.RolesSerializer = RolesSerializer;
//# sourceMappingURL=roles.serializer.js.map